<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据分配</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">线索公海</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                
                <a-button type="primary" @click="openimport">导入数据</a-button>
               
                <a-button type="primary" @click="openfp" :disabled="disabled">分配线索</a-button>
                <a-button type="danger" @click="delusers" :disabled="disabled">删除数据</a-button>
            </div>

            <div class="right">
                <a-select placeholder="项目标签" @change="tagseacrhChange" style="width:140px;margin-left:12px">
                     <a-select-option v-for="item in taglist" :value="item.imtid" :key="item.imtid">
                        {{item.title}}
                    </a-select-option>
                </a-select>
                <a-range-picker @change="ondateChange" :locale="locale" style="width:260px"/>
                <!-- <a-date-picker :locale="locale" @change="ondateChange" placeholder="创建时间"/> -->
                 <a-select placeholder="线索分配状态" @change="typehandleChange" style="width:140px;margin-left:12px">
                     <a-select-option :value="0" >
                        全部
                    </a-select-option>
                    <a-select-option :value="2" >
                        未分配
                    </a-select-option>
                    <a-select-option :value="1" >
                        已分配
                    </a-select-option>
                </a-select>

                <a-input-search style="width:220px"
                    placeholder="关键字手机"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
        </div>

         <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}"  rowKey="usxsid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="type" slot-scope="text">
                        <a-tag v-if="text" color="green">已分配</a-tag>
                        <a-tag v-else color="orange">未分配</a-tag>

                    </span>

                    <span slot="video" >
                        <!-- <video :src="text"></video> -->
                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 导入数据 -->
        <a-modal
            title="批量导入"
            :visible="importvisible"
            :confirm-loading="importconfirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            okText="确定"
            cancelText='取消'
            >
            <!-- <div class="import-text">
                <svg width="27px" height="20px" viewBox="0 0 27 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="交互组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="业务组件" transform="translate(-120.000000, -1433.000000)" fill-rule="nonzero"><g id="编组-3备份-7" transform="translate(60.000000, 1301.000000)"><g id="Simple-modal备份-5" transform="translate(12.000000, 52.000000)"><g id="编组-5" transform="translate(46.000000, 76.000000)"><g id="批量导入"><rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="30" height="30"></rect><path d="M29,18.5491733 C29,20.0559059 28.4735,21.3376513 27.417125,22.4046361 C26.36075,23.4716209 25.088375,24 23.6,24 L8.301125,24 C6.56975,24 5.08475,23.3795807 3.8495,22.1319243 C2.617625,20.8876768 2,19.391171 2,17.6355889 C2,16.404977 2.327375,15.2698142 2.9855,14.2266917 C3.643625,13.1835691 4.5245,12.4029317 5.628125,11.8813704 C5.61125,11.5984319 5.59775,11.3938981 5.59775,11.2711778 C5.59775,9.26333731 6.303125,7.54866201 7.707125,6.13056076 C9.111125,4.71245952 10.80875,4 12.796625,4 C14.258,4 15.597875,4.41247656 16.8095,5.23742969 C18.021125,6.06238282 18.905375,7.15663883 19.458875,8.51678882 C20.12375,7.9270496 20.903375,7.63729334 21.791,7.63729334 C22.78325,7.63729334 23.63375,7.99181865 24.33575,8.70427817 C25.041125,9.41673769 25.392125,10.2723709 25.392125,11.2745867 C25.392125,11.993864 25.19975,12.6483723 24.815,13.2347026 C26.033375,13.5278677 27.032375,14.1687404 27.815375,15.1573206 C28.605125,16.1493097 29,17.2776547 29,18.5491733 Z M9.20225,14.9152889 C9.20225,15.0482359 9.24275,15.1573206 9.3305,15.242543 C9.414875,15.3277655 9.522875,15.3720811 9.6545,15.3720811 L12.80675,15.3720811 L12.80675,20.3695245 C12.80675,20.4922448 12.850625,20.5979206 12.938375,20.6899608 C13.026125,20.7785921 13.134125,20.8229078 13.255625,20.8229078 L15.955625,20.8229078 C16.077125,20.8229078 16.18175,20.7785921 16.272875,20.6899608 C16.364,20.6013295 16.4045,20.4922448 16.4045,20.3695245 L16.4045,15.3686722 L19.553375,15.3686722 C19.674875,15.3686722 19.7795,15.3243566 19.870625,15.2357252 C19.958375,15.1470939 20.00225,15.0380092 20.00225,14.9152889 C20.00225,14.7823419 19.96175,14.6732572 19.874,14.5880348 L14.922875,9.58718255 C14.8385,9.50196012 14.7305,9.45764445 14.598875,9.45764445 C14.46725,9.45764445 14.35925,9.49855122 14.274875,9.58718255 L9.344,14.5743992 C9.2495,14.6868928 9.20225,14.7993864 9.20225,14.9152889 L9.20225,14.9152889 Z" id="形状" fill="#4F7AFD"></path></g></g></g></g></g></g>
                </svg>
                <h3>上传填好的信息表</h3>
                <p>文件后缀名必须为xlsx,文件大小不得大于10M,最多支持导入10000条数据</p>
            </div> -->
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="线索来源">
                    <a-select placeholder="请选择线索来源" @change="lyhandleChange">
                        <a-select-option :value="item.ussid" v-for="item in sourcedata" :key="item.ussid">
                            {{item.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="项目标签">
                    <a-select placeholder="请选择线索来源" @change="taghandleChange">
                        <a-select-option :value="item.imtid" v-for="item in taglist" :key="item.imtid">
                            {{item.title}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
            <div class="import-form">

                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button v-if="buttonshow"> <a-icon type="folder-open" /> 上传文件 </a-button>
                </a-upload>
                <a v-if="buttonshow" :href="url" download="线索导入模板.xls">下载数据模板</a>
            </div>
        </a-modal>

        <!-- 分配线索 -->
        <a-modal
        title="分配线索"
        :visible="fpvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="确定"
        cancelText='取消'
        >
            <div class="bgLog">
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in userlist" :key="item.aid" :value="item.aid">
                                {{item.username}} （ {{item.name}} ）
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

    </div>
</template>
<style>

</style>
<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
const columns = [
    {title: 'ID',dataIndex: 'usxsid',key: 'usxsid',width:100},
    {title: '姓名',dataIndex: 'username',key: 'username',width:120},
    {title: '电话',dataIndex: 'telephone',key: 'telephone',width:140},
    {title: '备注',dataIndex: 'remarks',key: 'remarks',width:260},
    {title: '线索来源',dataIndex: 'title_sources',key: 'title_sources',width:120},
    {title: '所属人',dataIndex: 'username_kf',key: 'username_kf',width:120},
    {title: '项目标签',dataIndex: 'title_itemtag',key: 'title_itemtag',width:120},
    {title: '分配状态',dataIndex: 'aid',key: 'aid',scopedSlots: { customRender: 'type' },width:120},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' },width:120},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            // rowSelection,
            tablex:"100%",
            disabled:true,
            importvisible:false,
            confirmLoading:false,
            importconfirmLoading:false,
            buttonshow:true,
            fileList:[],
            uploading: false,
            file:{},
            ussid:"",
            url:"https://fxbkfadmin.13524.net/uploads/%E7%BA%BF%E7%B4%A2%E5%88%97%E8%A1%A8.xlsx",

            fpvisible:false,

            fplist:[{id:1,name:'坐席1'}],

            sourcedata:"",
            delids:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),

            userlist:"",
            fpaid:"",
            fptype:2,

            starttime:"",
            endtime:"",
            selectedRowKeys:[],
            searchtext:"",

            taglist:[],
            imtid:"",
            searchiteimid:""
        }
    },
    watch: {
      windowHeight (val) {
        this.tablex=val-300
      },
    },
    mounted(){
        // this.tablespinning=false
        this.getsource()
        this.fetch()
        this.getuserlist()
        this.gettaglist()

        window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{
        onSearch(){
            this.fetch()
        },

        // 项目标签
        gettaglist(){
            this.$axios.post('/api/system/itemtaglist',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.taglist=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 所属人列表
        getuserlist(){
            this.$axios.post("/api/system/adminlist",{
                pagesize:50,
                iskf:1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.userlist=res.data.data.data
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },

        handleCancel(){
            this.importvisible=false
            this.fpvisible=false
        },

         // 导入数据
        lyhandleChange(value){
             console.log(value)
             this.ussid=value
         },
        taghandleChange(value){
            this.imtid=value
         },
        openimport(){
            this.importvisible=true
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.buttonshow=true
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            this.buttonshow=false
            return false;
        },
        importOk(){
            this.importconfirmLoading=true
            var formData = new FormData();
            console.log(this.fileList[0])
            var file=this.fileList[0]
            console.log(file)
            formData.append('imgFile',file)
            formData.append('ussid',this.ussid)
            formData.append('imtid',this.imtid)
            console.log(formData)
            this.$axios.post("/api/user/adduserxsimport",formData,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    'Content-Type':'multipart/form-data',
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.importconfirmLoading=false
                    this.importvisible=false
                    this.fetch()
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },
        

        // 删除
         onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        delclue(value){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(value)
                },
                onCancel() {

                },
            });
        },
        handok(value){
            this.$axios.post('/api/user/deluserxs',{
                usxsids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.disabled=true
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },



        // 分配线索
        openfp(){
            this.fpvisible=true

        },
        bghandleChange(value){
            this.fpaid=value
        },
        bghandleOk(){
            var id=this.delids.join(",")
            this.$axios.post('/api/user/fptuserxs',{
                aid:this.fpaid,
                usxsids:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.fpvisible=false,
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 来源列表
        getsource(){
            this.$axios.post('/api/user/usersourceslist',{
                pagesize: 100,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data.data
                    this.sourcedata=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        
        
        // 日期范围
        ondateChange(date,dateString){
       
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },
        // 选择坐席
        userhandleChange(){

        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 分配状态
        typehandleChange(value){
            this.fptype=value
            this.fetch()
        },
        // 项目标签
        tagseacrhChange(value){
            this.searchiteimid=value
            this.fetch()
        },
            // 数据
        fetch(params = {}){
            this.$axios.post('/api/user/userxslist',{
                pagesize: this.size,
                page:this.currentpage,
                isgh:1,
                isfp:this.fptype,
                endtime:this.endtime,
                starttime:this.starttime,
                search:this.searchtext,
                imtid:this.searchiteimid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    var data=res.data.data.data
                    this.data=data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cluelog/cluesea.vue